import * as React from "react";

import PropTypes from "prop-types";
import { withRouter } from "@lululemon/ecom-core";

const ConditionalRedirect = ({
  shouldRedirect = false,
  location,
  router,
  from,
  to,
}) => {
  const { pathname } = location;

  let initialValue = false;
  if (process.browser) {
    initialValue = window.sessionStorage.getItem("hasRedirected");
  }

  const hasRedirected = React.useRef(initialValue);

  React.useEffect(() => {
    if (hasRedirected.current) return;
    if (!shouldRedirect) return;

    if (from === pathname) {
      window.sessionStorage.setItem("hasRedirected", true);
      router.replace(to);
      hasRedirected.current = true;
    }
  }, [shouldRedirect, pathname, from, to, hasRedirected]);

  return null;
};

export default withRouter(ConditionalRedirect);

ConditionalRedirect.defaultProps = {
  shouldRedirect: false,
};

ConditionalRedirect.propTypes = {
  shouldRedirect: PropTypes.bool,
};
